import axios from "axios";
import { axiosInstance } from "./intreceptor";

let cache = {};
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
});

class useDepartmentService {
  createDepartment = (user_info) => {
    return axiosInstance
      .post("/department/createdepartment", user_info)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  };

  updateDepartment = (user_info) => {
    return axiosInstance
      .post("/department/updatedepartment", user_info)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  };

  changeDepartmentStatus = (user_info) => {
    return axiosInstance
      .post("/department/changedepartmentstatus", user_info)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  };

  getDepartment = (comp_id) => {
    return axiosInstance
      .get("/department/getdepartments",{ params: {
        comp_id: comp_id, // Pass comp_id as a query parameter
      }})
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  };

  getActiveDepartment = (comp_id) => {
    return axiosInstance
      .get("/department/getactivedepartments",{params: {
        comp_id: comp_id, // Pass comp_id as a query parameter
      }})
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  };
}

export default new useDepartmentService();
